import {mocked} from 'utils';
import {default_global_data} from "../fixtures/global";

export const get_global_data = () => {
  return mocked(200, default_global_data)
};
